// styles
import { PsychologistListContainer } from 'src/pages/psychologist_list/PsychologistListPage.styled';
import { SpecialistCard } from '@mindly/ui-components';

type SkeletonPsychologistListPropsType = {
  psychologistCardSkeletonsToDraw: number;
};

export function SkeletonPsychologistList({ psychologistCardSkeletonsToDraw }: SkeletonPsychologistListPropsType) {
  return (
    <PsychologistListContainer>
      {Array.from({ length: psychologistCardSkeletonsToDraw }, (element, index) => index).map((cardNum) => (
        <SpecialistCard
          key={cardNum}
          loading={true}
          translations={{
            name: 'Психолог',
            year: ['рік', 'роки', 'років'],
            experiences: 'досвіду',
            hour: ['година', 'години', 'годин'],
            practice: 'практики',
            session: 'хв. сеанс',
            clients: ['клієнт', 'клієнти', 'клієнтів'],
            sessions: ['сесія', 'сесії', 'сесій'],
            by: 'за',
            match: 'підходить Вам на',
            reviews: ['відгук', 'відгуки', 'відгуків'],
          }}
        />
      ))}
    </PsychologistListContainer>
  );
}
